// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir] .chartWrapper--Q1AfT {
  margin: 30px auto;
  padding: 0;
}

.canvasWrapper--PZQOi {
  height: 850px;
}

.loader--YNj7C {
  width: 100%;
  height: 100%;
}

.loaderImage--_BpHH {
  width: 100%;
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/Chartjs/styles.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":[".chartWrapper {\n  margin: 30px auto;\n  padding: 0;\n}\n\n.canvasWrapper {\n  height: 850px;\n}\n\n.loader {\n  width: 100%;\n  height: 100%;\n}\n\n.loaderImage {\n  width: 100%;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartWrapper": `chartWrapper--Q1AfT`,
	"canvasWrapper": `canvasWrapper--PZQOi`,
	"loader": `loader--YNj7C`,
	"loaderImage": `loaderImage--_BpHH`
};
export default ___CSS_LOADER_EXPORT___;
